import { useEffect, useRef, useState } from 'react';
import { cls } from '../lib/util';

/** The Gooflord level ring, 0 → win level. Bursts when the level rises. Colour-blind safe: the number is always shown. */
export function LevelRing({ level, max, size = 56, label, mine }: { level: number; max: number; size?: number; label?: string; mine?: boolean }) {
  const r = size / 2 - 5, c = 2 * Math.PI * r;
  const frac = Math.min(1, level / max);
  const prev = useRef(level);
  const [burst, setBurst] = useState(false);
  useEffect(() => { if (level > prev.current) { setBurst(true); const t = setTimeout(() => setBurst(false), 900); prev.current = level; return () => clearTimeout(t); } prev.current = level; }, [level]);
  return (
    <div className={cls('ring', mine && 'mine', burst && 'burst')} style={{ width: size, height: size }} role="img" aria-label={`${label ?? 'Gooflord'} level ${level} of ${max}`}>
      <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={r} className="track" />
        <circle cx={size / 2} cy={size / 2} r={r} className="fill" strokeDasharray={c} strokeDashoffset={c * (1 - frac)} transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      </svg>
      <div className="num" style={{ fontSize: size * 0.4 }}>{level}</div>
    </div>
  );
}
